import React from 'react';
import { SvgIcon } from '@material-ui/core';

const ThirdStepIcon = (props) => (
  <SvgIcon
    width="39.721"
    height="50.129"
    viewBox="0 0 39.721 50.129"
    {...props}
  >
    <g id="Palier3" transform="translate(-14.343 -5)">
      <g id="Groupe_6159" transform="translate(14.343 5)">
        <path
          id="Tracé_3727"
          d="M46.039 45.541h-3.2v-5.466l4.989 2.625-1.446-8.431 6.125-5.969-8.465-1.23-3.786-7.67-3.786 7.668L28 28.3l6.125 5.971-1.441 8.429 4.992-2.625v5.466h-3.2v4.077h-3.258v11.889h18.076V49.618h-3.255v-4.077zm-11.01-6.068l1-5.821-4.229-4.121 5.844-.849 2.613-5.3 2.613 5.3 5.844.849-4.229 4.121 1 5.821-5.227-2.748zm4.414-.326l.813-.427.813.428v6.394h-1.626zm-3.2 8.16h8.035v1.628h-8.04zm11.29 4.077v8.358h-14.55v-8.358z"
          transform="translate(-20.395 -11.378)"
        />
        <path
          id="Tracé_3728"
          d="M51.183 80.209H39.617v4.855h11.566v-4.855zM49.418 83.3h-8.035v-1.325h8.035z"
          transform="translate(-25.54 -38.319)"
        />
        <rect
          id="Rectangle_1370"
          width="1.761"
          height="6.305"
          rx=".88"
          transform="translate(18.98)"
        />
        <rect
          id="Rectangle_1375"
          width="1.761"
          height="6.305"
          rx=".88"
          transform="translate(9.088 3.074) rotate(-30)"
        />
        <rect
          id="Rectangle_1376"
          width="1.761"
          height="6.305"
          rx=".88"
          transform="translate(27.607 8.535) rotate(-150)"
        />
        <rect
          id="Rectangle_1377"
          width="1.761"
          height="6.305"
          rx=".88"
          transform="translate(32.037 13.844) rotate(-120)"
        />
        <rect
          id="Rectangle_1378"
          width="1.761"
          height="6.305"
          rx=".88"
          transform="translate(33.416 20.741) rotate(-90)"
        />
        <rect
          id="Rectangle_1379"
          width="1.761"
          height="6.305"
          rx=".88"
          transform="translate(31.16 27.403) rotate(-60)"
        />
        <rect
          id="Rectangle_1380"
          width="1.761"
          height="6.305"
          rx=".881"
          transform="translate(2.223 10.691) rotate(-60)"
        />
        <rect
          id="Rectangle_1381"
          width="1.761"
          height="6.305"
          rx=".88"
          transform="translate(0 20.741) rotate(-90)"
        />
        <rect
          id="Rectangle_1382"
          width="1.761"
          height="6.305"
          rx=".88"
          transform="translate(3.1 30.556) rotate(-120)"
        />
      </g>
    </g>
  </SvgIcon>
);

export default ThirdStepIcon;
